// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lGkr","footer":"styles_footer__36jap"};